module.exports = __webpack_public_path__ + "static/media/journal.e5d15edb.png";